// import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { JobBoardFormValues } from "src/models/JobBoard.model";
import { useState } from "react";
import { TbPlus } from "react-icons/tb";
import ATMFilePickerWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";

type Props = {
  formikProps: FormikProps<JobBoardFormValues>;
  onClose: () => void;
  editorValue?: string;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};

const jobType = [
  {
    label: "Internship",
    value: "INTERNSHIP",
  },
  {
    label: "Part Time",
    value: "PART_TIME",
  },
  {
    label: "Full Time",
    value: "FULL_TIME",
  },
];
const workMode = [
  {
    label: "Remote",
    value: "REMOTE",
  },
  {
    label: "On-Site",
    value: "ON_SITE",
  },
  {
    label: "Hybrid",
    value: "HYBRID",
  },
];

const JobForm = ({
  formikProps,
  onClose,
  editorValue,
  formType,
  setSaveNextChecked,
  saveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const [selectedWorkMode, setSelectedWorkode] = useState();
  const [Benefit, setShowBenefit] = useState(false);
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 overflow-hidden">
      <div className="flex items-center justify-between h-fit">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Job" : "Update Job"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="grid flex-1 grid-cols-3 gap-4 overflow-scroll">
        {/* comapany name */}
        <ATMTextField
          required
          name="CompanyName"
          value={values?.CompanyName}
          onChange={(e) => setFieldValue("CompanyName", e.target.value)}
          label="Company Name"
          placeholder="Enter company name"
          onBlur={handleBlur}
        />
        {/* company logo */}
        <ATMFilePickerWrapper
          name="companyLogo"
          label="Company Logo"
          placeholder="select file"
          selectedFile={values?.companyLogo}
          onSelect={(imgUrl) => {
            setFieldValue("companyLogo", imgUrl);
          }}
        />
        {/* job role */}
        <ATMTextField
          required
          name="JobRole"
          value={values?.JobRole}
          onChange={(e) => setFieldValue("JobRole", e.target.value)}
          label="Job Role"
          placeholder="Enter job role"
          onBlur={handleBlur}
        />
        {/* Experience */}
        <ATMTextField
          name="Experience"
          value={values?.Experience}
          onChange={(e) => setFieldValue("Experience", e.target.value)}
          label="Experience"
          placeholder="Enter experience"
          onBlur={handleBlur}
        />
        {/* job type */}
        <ATMSelect
          name="JobType"
          required
          value={values?.JobType}
          onChange={(newValue) => setFieldValue("JobType", newValue)}
          onBlur={handleBlur}
          label="Job Type"
          placeholder="Select job type"
          options={jobType}
        />
        {/* work mode */}
        <ATMSelect
          name="WorkMode"
          required
          value={values?.WorkMode}
          onChange={(newValue) => {
            setFieldValue("WorkMode", newValue);
            setSelectedWorkode(newValue?.value);
          }}
          onBlur={handleBlur}
          label="Job Mode"
          placeholder="Select job mode"
          options={workMode}
        />

        {/* job Link */}
        <ATMTextField
          disabled={selectedWorkMode === "REMOTE"}
          name="jobLocation"
          value={values?.jobLocation}
          onChange={(e) => setFieldValue("jobLocation", e.target.value)}
          label="Job Location"
          placeholder="Enter job location"
          onBlur={handleBlur}
        />

        {/* job location */}
        <ATMTextField
          // disabled={selectedWorkMode === "REMOTE"}
          name="jobLink"
          value={values?.jobLink}
          onChange={(e) => setFieldValue("jobLink", e.target.value)}
          label="Job Link"
          placeholder="Enter job Link"
          onBlur={handleBlur}
        />

        {/* About company */}
        <div className="z-0 col-span-3">
          <ATMHTMLEditor
            key={editorValue}
            label="About Company"
            value={values?.aboutComapny}
            placeholder="Write here...."
            onChange={(newValue: any) => {
              setFieldValue("aboutComapny", newValue);
            }}
          />
        </div>

        {/* Questions */}
        <div className="z-0 col-span-3">
          <ATMHTMLEditor
            key={editorValue}
            label="Requirements"
            required
            value={values?.requirements}
            placeholder="Write requirements here...."
            onChange={(newValue: any) => {
              setFieldValue("requirements", newValue);
            }}
          />
        </div>
        <div className="z-0 col-span-3">
          <ATMHTMLEditor
            key={editorValue}
            label="Responsibilities"
            required
            value={values?.responsibilities}
            placeholder="Write reponsibilities here...."
            onChange={(newValue: any) => {
              setFieldValue("responsibilities", newValue);
            }}
          />
        </div>
        {values.benefitsAndPerks.length > 0 ? (
          // Render something if there are benefits and perks
          <div>{/* Your component to display benefits and perks */}</div>
        ) : !Benefit ? (
          <ATMLoadingButton
            onClick={() => {
              setShowBenefit(true);
            }}
            className="bg-transparent border-none hover:bg-primary-dark hover:text-white text-primary-dark w-fit"
          >
            <TbPlus />
            Add Benefits and Perks
          </ATMLoadingButton>
        ) : null}

        {Benefit || values.benefitsAndPerks.length ? (
          <div className="z-0 col-span-3">
            <ATMHTMLEditor
              key={editorValue}
              label="Benefits and Perks"
              value={values?.benefitsAndPerks}
              placeholder="Write reponsibilities here...."
              onChange={(newValue: any) => {
                setFieldValue("benefitsAndPerks", newValue);
              }}
            />
          </div>
        ) : null}
      </div>

      <div className="h-fit">
        {formType === "Add" && (
          <div>
            <ATMCheckbox
              label="Save and Next"
              checked={saveNextChecked}
              onChange={(checked) => {
                setSaveNextChecked(checked);
              }}
            />
          </div>
        )}
        <div>
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default JobForm;
